import React from "react";
import { Box, Chip, Switch, Typography } from "@mui/material";
import { MobileCard } from "@ui/components/card";
import { SMenuTrigger } from "@ui/components/menu/SMenu";
import { useTranslation } from "react-i18next";
import { between } from "@ui/components/style/style";
export const RoleCard = ({ row, onMenuClick, onToggleActive, canEdit, }) => {
    var _a;
    const { t } = useTranslation(["common"]);
    return (React.createElement(MobileCard, null,
        React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { gap: 1 }) },
            React.createElement(Typography, { variant: "subtitle1", noWrap: true, sx: { minWidth: 0 } }, row.name),
            React.createElement(SMenuTrigger, { onClick: (event) => {
                    event.stopPropagation();
                    onMenuClick(event, row.id);
                }, size: "medium" })),
        React.createElement(Box, { sx: Object.assign(Object.assign({}, between), { gap: 1 }) },
            React.createElement(Chip, { label: `${(_a = row.assignedUsersCount) !== null && _a !== void 0 ? _a : 0} ${t("common:grid.users")}`, size: "small", variant: "soft" }),
            React.createElement(Switch, { checked: row.isActive !== false, onChange: () => onToggleActive(row), onClick: (e) => e.stopPropagation(), disabled: !canEdit || row.isSystemRole, size: "small" }))));
};
